const sortCCValues = (a, b) => {
  // Convert both values to strings for consistent processing
  const strA = String(a);
  const strB = String(b);

  // Extract numeric parts
  const numA = parseInt(strA, 10);
  const numB = parseInt(strB, 10);

  // Check if values are purely numeric
  const isANumeric = !isNaN(numA) && strA === numA.toString();
  const isBNumeric = !isNaN(numB) && strB === numB.toString();

  // Check if values are alphanumeric with numeric prefixes
  const isAAlphanumeric = !isANumeric && !isNaN(numA);
  const isBAlphanumeric = !isBNumeric && !isNaN(numB);

  // Rule 1: Compare numeric parts first
  if (!isNaN(numA) && !isNaN(numB)) {
    if (numA !== numB) return numA - numB;

    // Rule 2: Handle suffixes when numeric parts are equal
    const suffixA = strA.slice(numA.toString().length);
    const suffixB = strB.slice(numB.toString().length);

    // Pure numeric comes before alphanumeric with the same numeric prefix
    if (suffixA === "" && suffixB !== "") return -1;
    if (suffixA !== "" && suffixB === "") return 1;

    // Compare suffixes lexicographically
    return suffixA.localeCompare(suffixB);
  }

  // Rule 3: Purely numeric values come before purely non-numeric strings
  if (isANumeric && !isBNumeric) return -1;
  if (isBNumeric && !isANumeric) return 1;

  // Rule 4: Alphanumeric with numeric prefix comes before purely non-numeric strings
  if (isAAlphanumeric && !isBAlphanumeric) return -1;
  if (isBAlphanumeric && !isAAlphanumeric) return 1;

  // Rule 5: Lexicographic comparison for purely non-numeric strings
  return strA.localeCompare(strB);
};

export default sortCCValues;
